import { FunctionComponent } from 'react';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';

import { Button } from '../../atoms/button';
import { SafeFormattedMessage } from '../../formatters';
import { ConnectionErrorIcon, RefreshIcon } from '../../protons/icons';

import BaseErrorBoundary from './BaseErrorBoundary';
import messages from './messages';

interface ChunkLoadErrorBoundaryProps {
  isFullScreen?: boolean;
}

const ChunkLoadErrorBoundary: FunctionComponent<
  ChunkLoadErrorBoundaryProps
> = ({ isFullScreen = true }) => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <BaseErrorBoundary
      icon={<ConnectionErrorIcon color="#fff" size="80px" />}
      titleMessage={messages.chunkErrorBoundaryTitle}
      bodyMessage={messages.chunkErrorBoundaryDidactic}
      isFullScreen={isFullScreen}
    >
      <Button
        type={BUTTON_TYPES.BUTTON}
        onClick={refreshPage}
        icon={<RefreshIcon />}
      >
        <SafeFormattedMessage {...messages.refresh} />
      </Button>
    </BaseErrorBoundary>
  );
};

export default ChunkLoadErrorBoundary;
